<div id="doubleY" #doubleY class="doubleaxis{{index}} h-100 w-100">
    <p *ngIf="!doubleYData?.length" class="mt">No Data</p>
</div>